export default __webpack_public_path__ + "static/logo-2-0b8282e0a63dd69078524d71d55944c2.png";